import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from '@dossierhq/design';
export function BooleanFieldDisplay({ value }) {
    return (_jsx(Checkbox, { checked: !!value, children: value === true ? 'True' : value === false ? 'False' : _jsx("i", { children: "Not set" }) }));
}
//# sourceMappingURL=BooleanFieldDisplay.js.map